import axios from "../../axiosInstance";
const BillingbaseUrl = '/operation';
const MasterbaseUrl = '/master';
const ReportsbaseUrl = '/Reports';
const billingmasterUrl = 'master/billing';

class DsrService {
    getCustomerBasedCustomerType(Importer) {
        return axios.get(MasterbaseUrl + '/getCustomerBasedCustomerType?customerType=' + Importer)
    }
    getTransitAll() {
        return axios.get(MasterbaseUrl + '/getTransitAll')
    }
    getCustomLocation() {
        return axios.get(billingmasterUrl + '/getCustomLocation')
    }
    selectBranchDetails() {
        return axios.get(MasterbaseUrl + '/selectBranchDetails')
    }
    getEmployeeDetails() {
        return axios.get(MasterbaseUrl + '/getEmployeeDetails')
    }
    getDSR_Report(details){
        return axios.post(BillingbaseUrl+'/getDSR_Report',details)
    }
    getDSR_Report2(fromDate,toDate,importer_iec_no,transitTypeId,customId,clearanceStatus,regionalId,employeeId,operationType){
        return axios.get(BillingbaseUrl+'/getDSR_Report2?fromDate='+fromDate+'&toDate='+toDate+'&importer_iec_no='+importer_iec_no+'&transitTypeId='+transitTypeId+'&customId='+customId+
        '&clearanceStatus='+clearanceStatus+'&regionalId='+regionalId+'&employeeId='+employeeId+'&operationType='+operationType)
    }
    getDSR_Report3(details){
        return axios.post(BillingbaseUrl+'/getDSR_Report3',details)
    }
    Excelwrite(details) {
        return axios.post(ReportsbaseUrl + '/write', details)
    }
    writeXl(details) {
        return axios.post(ReportsbaseUrl + '/writeXl', details)
    }
}
export default new DsrService();